import { axiosRequest } from "../axios.config";

const courseLevelApi = {
  getAllCourseLevel: async () => {
    const url = "Level";
    const response = await axiosRequest.get(url);
    return response;
  },
};

export { courseLevelApi };
